import { render } from "./ProgramCard.vue?vue&type=template&id=0c418c00&scoped=true"
import script from "./ProgramCard.vue?vue&type=script&lang=js"
export * from "./ProgramCard.vue?vue&type=script&lang=js"

import "./ProgramCard.vue?vue&type=style&index=0&id=0c418c00&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c418c00"]])

export default __exports__